export default __webpack_public_path__ + "static/media/knight_of_pentacles.41648294.png";